import movementRoutes from './routes'

/* @ngInject */
const movementRun = (
  $transitions,
  storageHandler,
  $$movement
) => {
  $transitions.onSuccess({
    entering: movementRoutes.home.path,
  }, (trans) => {
    if (storageHandler.get('consult.movement.myMovement')) {
      $$movement.data.myMovement = storageHandler.get('consult.movement.myMovement')
    } else {
      $$movement.data.myMovement = $$movement.new.search()
    }

    if (storageHandler.get('consult.movement.myMovements')) {
      $$movement.data.myMovements = storageHandler.get('consult.movement.myMovements')
    } else {
      $$movement.data.myMovements.splice(0, $$movement.data.myMovements)
    }
  })

  $transitions.onBefore({
    from: movementRoutes.home.path,
  }, (trans) => {
    if (!trans.to().redirectTo) {
      storageHandler.save('consult.movement.myMovement', $$movement.data.myMovement)
      storageHandler.save('consult.movement.myMovements', $$movement.data.myMovements)
      $$movement.data.myMovement = null
      $$movement.data.myMovements = null
    }
  })
}

export default movementRun



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/consult/movement/movement.run.js